const Barra = ({ className, percentatge, textos }) => {
	return (
		<div className={`barra-container ${className || ''}`}>
			<div className={`e6 text-gris barra-referencies`}>
				<span>0</span>
				<span>50</span>
				<span>100</span>
			</div>
			<div className='barra'>
				<div style={{ width: `${percentatge}%` }}></div>
			</div>
			<div style={{ marginLeft: `calc(${percentatge}% - 3px)` }}>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='6'
					height='20'
					viewBox='0 0 6 20'
					fill='none'
				>
					<path
						d='M3 0L0.113249 5L5.88675 5L3 0ZM2.5 4.5L2.5 20L3.5 20L3.5 4.5L2.5 4.5Z'
						fill='black'
					/>
				</svg>
				<p
					className='e5 label-percentil'
					style={{
						transform: percentatge >= 50 ? 'translateX(-96%)' : 'none',
					}}
				>
					{textos.percentil}{' '}
					<span className='e4'>{String(percentatge).padStart(2, '0')}</span>
				</p>
			</div>
		</div>
	)
}
export default Barra
